import React, { useState } from "react";
import { toast } from "react-hot-toast";
import html2pdf from "html2pdf.js";
import Quote from "../components/Quote";

const CB = () => {
  const [length, setLength] = useState(8);
  const [breadth, setBreadth] = useState(15);
  const [height, setHeight] = useState(17);
  const wastagePercent = 5;
  const [rate, setRate] = useState(44);
  const [Qty, setQty] = useState(10);
  const [ply, setPly] = useState(3);
  const [gsmValues, setGsmValues] = useState([null, null, null]);
  const [result, setResult] = useState(null);

  // Update GSM inputs based on ply
  const handlePlyChange = (newPly) => {
    setPly(newPly);
    setGsmValues(new Array(newPly).fill("")); // Reset GSM to empty strings for 3 Ply
  };

  // Update individual GSM values
  const handleGsmChange = (index, value) => {
    const updatedGsmValues = [...gsmValues];
    updatedGsmValues[index] = value ? Number(value) : null; // Allow empty fields
    setGsmValues(updatedGsmValues);
  };

  const handleCalculate = () => {
    if (
      !length ||
      !breadth ||
      !height ||
      !rate ||
      !wastagePercent ||
      gsmValues.some((gsm) => gsm === null || gsm <= 0 || isNaN(gsm)) // Check if GSM values are valid
    ) {
      toast.error("Please fill in all the fields correctly.");
      return;
    }

    const reelSize = Number(height) + Number(breadth);
    const width = (Number(length) + Number(breadth)) * 2 + 2;

    const gsmSum = gsmValues.reduce((acc, gsm, index) => {
      if (gsm <= 0 || isNaN(gsm)) return acc; // Skip invalid GSM values
      return acc + (index % 2 !== 0 ? gsm * 1.5 : gsm); // Multiply odd indices by 1.5
    }, 0);

    const boxWeight = (gsmSum * reelSize * width) / 1550 / 1000;
    const weightAfterWastage = boxWeight * (1 + wastagePercent / 100);
    const finalPrice = weightAfterWastage * rate;

    // Log the result object before setting the state
    const result = {
      description: `This is a ${ply}-ply corrugated box with dimensions of ${length}x${breadth}x${height} inches with GSM of ${gsmValues.join(
        ","
      )}.`,
      qty: Qty,
      rate: rate,
      weightAfterWastage: parseFloat(weightAfterWastage.toFixed(2)),
      price: parseFloat(finalPrice.toFixed(2)), // Convert the price to a number
    };

    console.log(result); // This will print the result object in the console

    // Set the state with the result object
    setResult(result);

    setLength("");
    setBreadth("");
    setHeight("");
    setPly(3);
    setGsmValues(new Array(3).fill("")); // Reset GSM to empty strings for 3 Ply
  };
  const handleDownload = () => {
    // Select the HTML element to convert
    const element = document.getElementById("report");

    // Convert and download PDF
    const options = {
      margin: 1,
      filename: "Quote-GD.pdf",
      html2canvas: { scale: 2 },
      jsPDF: {
        orientation: "portrait", // Keeps the orientation as portrait
        unit: "mm", // Set units to millimeters for better precision
        format: "a4", // You can set other formats like "letter" if needed
        autoSize: true, // Automatically adjust size based on content
      },
    };

    html2pdf().set(options).from(element).save();
  };
  return (
    <div className="container">
      <div className="sv_section-title">
        <h2>Calculate Corrugation Box Weight and Cost</h2>
      </div>

      <div className="row justify-content-center">
        <div className="box-calculator">
          {/* Row 1: Length, Breadth, Height */}
          <div className="form-group-row">
            <div className="form-group">
              <label>Length (L):</label>
              <input
                type="number"
                value={length}
                placeholder="Length in inch"
                onChange={(e) => setLength(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Breadth (B):</label>
              <input
                type="number"
                value={breadth}
                placeholder="Breadth in inch"
                onChange={(e) => setBreadth(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Height (H):</label>
              <input
                type="number"
                value={height}
                placeholder="Height in inch"
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>
          </div>

          {/* Row 2: Ply and GSM Inputs */}
          <div className="form-group-row">
            <div className="form-group">
              <label>Ply Type:</label>
              <select
                value={ply}
                onChange={(e) => handlePlyChange(Number(e.target.value))}
              >
                <option value={3}>3 Ply</option>
                <option value={5}>5 Ply</option>
                <option value={7}>7 Ply</option>
              </select>
            </div>
            <div className="form-group">
              <label>GSM Values:</label>
              {gsmValues.map((gsm, index) => (
                <input
                  key={index}
                  type="number"
                  value={gsm}
                  placeholder={
                    index % 2 !== 0
                      ? "Fluting Part"
                      : `GSM for Ply ${index + 1}`
                  } // Change placeholder for odd indices
                  onChange={(e) => handleGsmChange(index, e.target.value)}
                  style={{
                    display: "block",
                    marginBottom: "5px",
                    color: index % 2 !== 0 ? "red" : "black", // Red for odd indices, black for even
                  }}
                />
              ))}

              <p>Important - Red one is used for Fluteing</p>
            </div>
          </div>

          {/* Row 3: Rate and Wastage Percent */}
          <div className="form-group-row">
            <div className="form-group">
              <label>Quantity:</label>
              <input
                type="number"
                value={Qty}
                placeholder="Quantity"
                onChange={(e) => setQty(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Rate:</label>
              <input
                type="number"
                value={rate}
                placeholder="rate"
                onChange={(e) => setRate(e.target.value)}
              />
            </div>
          </div>

          {/* Button */}
          <button
            onClick={handleCalculate}
            className="btn-primary w-100 mt-3 mb-3" // Add bottom margin to create space between buttons
          >
            Calculate
          </button>

          {/* Results */}
          {result !== null && (
            <div>
              {/* Download PDF Button */}
              <button
                onClick={handleDownload}
                className="btn-primary w-100 mt-3 mb-3" // Add bottom margin to create space between buttons
              >
                Download PDF
              </button>

              {/* Hidden or visible report content */}
              <div style={{ marginTop: "20px" }}>
                {" "}
                {/* Add top margin to create space above the Quote */}
                <Quote
                  description={result.description}
                  qty={result.qty}
                  rate={result.price}
                  weightAfterWastage={result.weightAfterWastage}
                  type='Box'
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CB;
